function getFirstName(name: string): string | null {
  if (!name || typeof name !== 'string') {
    return null;
  }

  return name.trim().split(' ')[0];
}

export default getFirstName;
